import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export function useMainTabNavigation() {
  const navigate = useNavigate();

  return useCallback(
    (tabId) => {
      if (tabId === 'home') navigate('/home');
      if (tabId === 'card') navigate('/card');
      if (tabId === 'history') navigate('/history');
      if (tabId === 'referral') navigate('/referral');
      if (tabId === 'support') navigate('/profile/help');
      if (tabId === 'profile') navigate('/profile');
    },
    [navigate]
  );
}
